import * as yup from 'yup';
import {MarkOwnerType} from '@/core/interface/api-interface';
import { validEmail } from '@/core/util/form-validation';

export const validateFormFields = async (value: any, schema: yup.AnySchema) => {
    let errors: null|string = null;
    await schema.validate(value, {abortEarly: false}).catch((err) => {
        errors = err.errors[0]
    });

    return errors;
}

export const ownerTypeSchema = yup.number().oneOf([MarkOwnerType.BUSINESS, MarkOwnerType.PERSON]).required();
export const ownerNamesSchema = yup.array().of(yup.string()).test(
    'have-on-valid-owner',
    'At least one owner name is required',
    (value) => {
        if (!value) {
            return false;
        }

        return value.some(name => {
            if (!name) {
                return false;
            }

            return name.length > 0;
        })
    }
);

export const emailSchema = yup.string()
    .required('Email is required')
    .test('is-valid-email', 'Invalid email address', value => validEmail(value || ''));

export const mobileNumberSchema = yup.string().required('Mobile number is required');
export const countrySchema = yup.string().required('Country is required');
export const addressSchema = yup.string().required('Address is required');
export const suburbSchema = yup.string().required('Suburb is required');
export const stateRegionSchema = yup.string().required('State/Region is required');
export const postCodeSchema = yup.string().required('Postcode is required');
export const businessNumberSchema = yup.string();
